import axios from "axios"
import moment from "moment"

import { API_ROOT_URL } from "."

const mapParticipant = (participant) => ({ 
  ...participant,
  comments: participant.comments.map(c => ({ ...c, createdAt: moment(c.createdAt).format("HH:mm YYYY-MM-DD") })),
})

export const fetchParticipant = async (participantId) => {
  const { data } = await axios.get(`${API_ROOT_URL}/users/participant/${participantId}/`)
  const participant = mapParticipant(data)
  return participant
}

export const getUser =(userId) => {
  return axios.get(`${API_ROOT_URL}/users/${userId}/`)
}
